import React from 'react';
import ReactDOM from 'react-dom';
import SharingLink from './SharingLink';

const componentElm = typeof document !== 'undefined' && document.getElementById('SharingLink-component');

if (componentElm) {
    const initialState = window.initialData.SharingLink;

    ReactDOM.render(<SharingLink {...initialState}/>, componentElm);
}

export default SharingLink;



// WEBPACK FOOTER //
// ./src/index.js